var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValessaOrganisch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 157.86,
    height: 135.64,
    viewBox: "0 0 157.86 135.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "startseite"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.75,81.18c17.49,12.49,41.12,14.64,56.89,29.29,4.29,3.99,7.81,8.76,12.05,12.8,11.61,11.08,29.58,15.95,44.01,9.44,14.43-6.51,22.73-25.57,15.52-39.96-1.96-3.92-4.88-7.36-6.23-11.53-2.16-6.68.09-13.83,1.04-20.76,2.55-18.74-5.39-38.71-20.12-50.58C122.2,3.68,112.52-.41,102.74.03c-6.68.31-13.06,2.67-19.63,3.89C60.99,8.06,37.2-.77,15.93,6.54c-32.36,11.13-8.5,60.84,10.82,74.64",
    fill: "#698cad"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValessaOrganisch);
export default __webpack_public_path__ + "static/media/valessa_organisch.b4a868e0be38bc165a81322d0a0cfacc.svg";
export { ForwardRef as ReactComponent };